import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
      <p className="text-xl text-gray-600 mb-8">Oops! The page you&apos;re looking for doesn&apos;t exist.</p>
      <Link
        to="/"
        className="px-6 py-3 text-white bg-button-primary hover:brightness-105 rounded-lg focus:outline-none focus:ring-4 focus:brightness-110 transition"
      >
        Go Back Home
      </Link>
    </div>
  );
};

export default NotFoundPage;